// ================================================================
// AgentC Customer Chat Library - Simplified Exports for NPM Users
// ================================================================

// ================================================================
// Main Chatbot Components (Recommended for most users)
// ================================================================

// 1. Floating Chat Button - Desktop/Mobile responsive floating chatbot
export { FloatingChatButton } from "./floating-chat-button";

// 2. Mobile Fullscreen Chat - Dedicated mobile fullscreen experience
export { MobileFullscreenChat } from "./mobile-fullscreen-chat";

// ================================================================
// Types (Essential for TypeScript users)
// ================================================================

// Message and Agent types for TypeScript support
export type { Message, AgentConfig } from "./floating-chat-button";

// ================================================================
// Advanced Components (Optional - for custom implementations)
// ================================================================

// Core chat functionality components
export { default as ChatDock } from "./chat-dock";
export { default as SuggestedQuestions } from "./suggested-questions";
